import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

angular.module('controllers')
    .controller(
        'CriticalError',
        (
            $scope, $rootScope, $document, $location, $window, $modal,
            $modalInstance, modalParams, Util, Auth,
        ) => {

            // set the modal type based on the params received
            function setErrorType() {

                const errorCode = String(modalParams.status);
                $scope.errorCode = errorCode;
                $scope.modalParamsObj = modalParams;

                if (errorCode === '400') {

                    return 'bad-request';

                } else if (errorCode === '401' || errorCode === '403') {

                    // logout user if the token has expired or access is unauthorized
                    Auth.removeLoginCookies();
                    $location.path('/auth/login');

                    if (Util.deepFind(modalParams, 'data.error') && modalParams.data.error === 'expired_token') {

                        return 'session-expired';

                    }

                    // Refresh the page if an one time token was reused
                    if (Util.deepFind(modalParams, 'data.error') && modalParams.data.error === 'used_token') {

                        if (window.external && ('CloseHtml' in window.external)) {

                            if ($location.$$search.retry_request) {

                                window.external.CloseHtml('error_used_token');

                            } else {

                                Mixpanel.send('ConnectWeb Spotlight Errors', {
                                    Error: modalParams.data.error,
                                    Description: modalParams.data.error_description,
                                    'Error Code': errorCode,
                                    'Client Id': 'spotlight',
                                });

                                // Send a retry request
                                $window.location.href = `${CWCONFIG.ssoConfig.spotlight.oauth}?retry_request=1`;

                            }

                        }

                        $window.location.href = $location.path();

                    }

                    return 'unauthorised';

                } else if (errorCode.startsWith('5')) {

                    return 'server-error';

                }

                return 'client-error';

            }

            $scope.modalParams = setErrorType();

            // append class to body when session expire modal appears
            angular.element($document[0].body).addClass('critical-error');

            $scope.refreshPage = () => {

                $window.location.href = $location.path();

            };

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/critical-error/critical-error.js